import bobtailAPI from '../axiosConfig'
import Entity from './entity'

// BE: Update after BE update
const Reserve = new Entity('balances')

Reserve.createJournalEntry = async (params) => {
  return (await bobtailAPI()).post(`${Reserve.baseUrl}/journal-entries`, {
    ...params,
  })
}

Reserve.getClientReserves = async (params) => {
  return (await bobtailAPI()).get(Reserve.baseUrl, {
    params,
  })
}

Reserve.getClientTotalReserve = async (id) => {
  return (await bobtailAPI()).get(`${Reserve.baseUrl}/total/${id}`)
}

Reserve.getJournalEntries = async (params) => {
  return (await bobtailAPI()).get(`${Reserve.baseUrl}/journal-entries`, {
    params,
  })
}

Reserve.getDiscrepancies = async (params) => {
  return (await bobtailAPI()).get(`${Reserve.baseUrl}/discrepancies`, {
    params,
  })
}

Reserve.historyDiscrepancies = async (params) => {
  return (await bobtailAPI()).get(`${Reserve.baseUrl}/history-discrepancies`, {
    params,
  })
}

Reserve.fixDiscrepancies = async (params) => {
  return (await bobtailAPI()).get(`${Reserve.baseUrl}/fix-discrepancies`, {
    params,
  })
}

export default Reserve
